import { render, staticRenderFns } from "./DiscussCreate.vue?vue&type=template&id=0bae23d6&"
import script from "./DiscussCreate.vue?vue&type=script&lang=js&"
export * from "./DiscussCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports